import { SystemProfile } from '../../types/entities';

export interface SystemProfileState {
  loading: boolean;
  loaded: boolean;
  pending: boolean;
  error?: string | undefined;
  profile: SystemProfile | undefined;
}

export const initialState: SystemProfileState = {
  loading: false,
  loaded: false,
  pending: false,
  profile: undefined
};
